
<template>
    <div class="form-overlay select-mention" :class="position">   

        <div class="steep1">
            <div class="nav-network hide-scrollbar">
                <div class="list-item-network">
                    <div class="item-network" v-if="this.pagesSelected.find(p=> p.network == 'facebook')" :class="{active : networkSelected == 'facebook'}" @click="()=>selectNetwork('facebook')"><i class="fa-brands fa-facebook"></i></div>
                    <div class="item-network" v-if="this.pagesSelected.find(p=> p.network == 'instagram')" :class="{active : networkSelected == 'instagram'}" @click="()=>selectNetwork('instagram')"><i class="fa-brands fa-instagram"></i></div>
                    <div class="item-network" v-if="this.pagesSelected.find(p=> p.network == 'linkedin')" :class="{active : networkSelected == 'linkedin'}" @click="()=>selectNetwork('linkedin')"><i class="fa-brands fa-linkedin"></i></div>
                    <div class="item-network" v-if="this.pagesSelected.find(p=> p.network == 'twitter')" :class="{active : networkSelected == 'twitter'}" @click="()=>selectNetwork('twitter')"><i class="fa-brands fa-twitter"></i></div>
                </div>
            </div>
            <div class="content searchMention">
                <div class="input">
                    <i class="fa-regular fa-magnifying-glass"></i>
                    <input :placeholder="textPlaceholder" v-model="textSearch" v-on:keyup.enter="sendSearchMention" ref="inputSearch">
                </div>
                <div class="list-item list-chosen-item hide-scrollbar">
                    <div class="item chosen-item" v-if="mentionData.mention && mentionData.mention[networkSelected]">
                        <div class="image">
                            <img :src="mentionData.mention[networkSelected].image ? mentionData.mention[networkSelected].image : saveUrlPictureUser[mentionData.mention[networkSelected].id] ? saveUrlPictureUser[mentionData.mention[networkSelected].id] : 'img/avatar.jpg'" alt="">
                            <i class="fa-solid fa-check"></i>
                        </div>
                        <div class="info">
                            <p class="username">{{ getUsername(mentionData.mention[networkSelected]) }}</p>
                            <p class="name">{{ getSubName(mentionData.mention[networkSelected])}}</p>
                        </div>
                        <i class="fa-regular fa-xmark" @click="removeMention(networkSelected)"></i>
                    </div>
                </div>
                <div class="list-item hide-scrollbar">
                    <span class="loader" v-if="stateLoader"></span>
                    <div class="item" v-else v-for="person in listPersonsAvailable.filter(p => !mentionData.mention || !mentionData.mention[networkSelected] || p.id !== mentionData.mention[networkSelected].id)" @click="selectMention(person)" :key="person.id">
                        <img :src="getPicture(person)" alt="">
                        <div class="info">
                            <p class="username">{{ getUsername(person) }}</p>
                            <p class="name">{{ getSubName(person) }}</p>
                        </div>
                    </div>
                    
                </div>
            </div>

        </div>
        <div v-if="steep == 1" class="btn-secondary" @click="close">Fermer</div>
        <div v-else class="btn-secondary" @click="steep = 1">Retour</div>
       
    </div>
</template>


<script>
    import { EventBus } from '@/event-bus';
    import store from './../../../../store/index.js'
    import Queuer from '../../../../utils/Queuer.js'
    import minxinBot from '../../../mixins/Bots.vue'

    const networkSort = ['facebook','instagram','linkedin','twitter']

    export default {
        mixins: [minxinBot],
        props: {
            mentionData: {
                type: Object,
                default: ()=>({})
            },
            idMention: {
                type: Number,
                default: null
            },
            position: {
                type: String,
                default: 'left'
            },
        },
       

        data() {
            return {
                steep : 1,
                textSearch : this.mentionData.textDefault,
                lastIdEvent : 0,
                stateLoader : false,
                listPersonsAvailable : [],
                timeoutInitSearch : null,
                networkSelected :  networkSort.find(network => this.$store.getters['selectPage/selectPagePageSelected'].some(pageItem => pageItem.network === network)),

                saveUrlPictureUser : {},
                queueLoadImage : null
            }
        },

        mounted() {
            EventBus.$on('resultSearchFromSelectMention', this.receveidPerson);
            this.sendSearchMention()
            this.$nextTick(() => {
                this.$refs.inputSearch.focus();
            })
        },

        methods: {
            close() {
                EventBus.$emit("eventCloseSelectMention",this.idMention)
                this.$emit('close')
            },

            sendSearchMention() {
                if (this.timeoutInitSearch) clearTimeout(this.timeoutInitSearch)
                this.stateLoader = true
                this.lastIdEvent = new Date().getTime()
                EventBus.$emit("eventSearchFromSelectMention",this.textSearch, this.networkSelected, this.lastIdEvent, this.idMention)
            },

            async receveidPerson(persons,idEvent) {
                if ( this.lastIdEvent == idEvent) {
               
                    this.stateLoader = false

                    if (persons) {
                        this.listPersonsAvailable = persons
                    }else{
                        this.listPersonsAvailable  = []
                        return
                    }
                    
                    
                    switch (this.networkSelected) {
                        case 'facebook': {

                            let pageFacebook = this.pagesSelected.find(p=> p.network == this.networkSelected)
                            if (pageFacebook) {

                                if (this.queueLoadImage instanceof Queuer) this.queueLoadImage.stop();
                                
                                this.queueLoadImage = new Queuer({
                                    data: JSON.parse(JSON.stringify(persons)),
                                    task: async (m) => {
                                        //verifier si le liens de l'image existe déja pour eviter une requette
                                        if (!([persons.id] in this.saveUrlPictureUser)) {
                                            const res = await this.getAvatarMentionByApi(pageFacebook.id, m.id);
                                            if (res && res.body && res.body.avatar && res.body.avatar.data && res.body.avatar.data.url) {
                                                this.$set(this.saveUrlPictureUser, m.id, res.body.avatar.data.url);
                                            }
                                        }
                                        this.queueLoadImage.unlock()
                                    }
                                })
                                this.queueLoadImage.init()
                            }
                            break;
                        }
                    }
                }
            },

            selectMention(person) {
                this.$set(this.mentionData.mention, this.networkSelected, person)
                EventBus.$emit("eventClickSelectMention",this.networkSelected, person, this.idMention)
                this.steep = 1
            },

            removeMention(networkSelected) {
                this.$set(this.mentionData.mention, networkSelected, null)
                EventBus.$emit("eventRemoveSelectMention", networkSelected, this.idMention)
            },

            selectNetwork(network) {
                if (this.networkSelected !== network) {
                    this.listPersonsAvailable = []
                }
                
                this.networkSelected = network
                this.sendSearchMention() 
            },

            getUsername(person) {
                switch (this.networkSelected) {
                    case 'facebook': {
                        return person.name ? person.name : person.id
                    }
                    case 'linkedin': {
                        return person.name ? person.name : person.id
                    }
                    case 'twitter': {
                        return person.name ? person.name : person.id
                    }
                    default: {
                        return person.id ? person.id : person.name
                    }
                }
            },


            getSubName(person) {
                switch (this.networkSelected) {
                    case 'facebook': {
                        return person.id ? person.id : person.name
                    }

                    case 'linkedin': {
                        return person.name ? person.name : person.id
                    }

                    case 'twitter': {
                        return person.username ? person.username : person.id
                    }
                        
                    default: {
                        return person.id ? person.id : person.name
                    }
                }
            },

            getPicture(person) {

                switch (this.networkSelected) {
                    case 'twitter': {
                        return person.profile_image_url ? person.profile_image_url : 'img/avatar.jpg'
                    }

                    case 'facebook': {
                        return this.saveUrlPictureUser[person.id] ? this.saveUrlPictureUser[person.id] : 'img/avatar.jpg'
                    }  
                
                    default:{
                        return person.image ? person.image : 'img/avatar.jpg'
                    }
                }

                
            }

        },

        computed: {
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'];
            },

            mentionSelected() {
                return this.mentionData.mention[this.networkSelected]
            },

            textPlaceholder() {
                switch (this.networkSelected) {
                    case 'instagram':
                        if (!this.pagesSelected.find(p => p.network == 'instagram' && p.story_config && p.story_config.created)) {
                            return 'Nom spécifique de la personne'
                        }
                       
                        break;
                    case 'linkedin':
                        if (!this.pagesSelected.find(p => p.network == 'linkedin' && p.bot_status && p.story_config && p.story_config.created)) {
                            return "Nom ou url spécifique de la compagnie"
                        }
                           
                        break;

                    case 'twitter':
                        return 'Nom spécifique de la personne'
                }

                return 'Rechercher une personne'
            }
        },

        watch: {
            textSearch(newValue, oldValue) {
                if (this.timeoutInitSearch) clearTimeout(this.timeoutInitSearch)
                this.stateLoader = true
                this.timeoutInitSearch = setTimeout(() => {
                    this.sendSearchMention()
                },1000)
            },

           
        },

        beforeDestroy () {
            EventBus.$off('resultSearchFromSelectMention', this.receveidPerson);
        }
    }
</script>
    